import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { TreeStoreEffects } from './tree.effects';
import { treeReducer } from './tree.reducer';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    StoreModule.forFeature('navigationTree', treeReducer),
    EffectsModule.forFeature([TreeStoreEffects]),
  ],
})
export class TreeStateModule {}
